import { createFileRoute, redirect } from "@tanstack/react-router"
export const Route = createFileRoute("/_authenticated/companies/$companyId/services/$serviceId/assignments")({
    beforeLoad: ({ params }) => {
        throw redirect({ to: "/companies/$companyId/services/$serviceId", params, replace: true })
    },
})
